<template>
    <div class="about-rad">
        <h3>R&D</h3>
        <p class="indent">As a major manufacturer of rolled and extruded aluminum and aluminum alloy semi-finished products, the Company is increasingly focusing on development. A team of experts from R&D in collaboration with experts from Sales and Marketing, continue to conduct market research and develop new products, which are tailored and adapted to the specific needs of all customers.</p>

      <p class="indent" style="text-align:center;">
        <img style="width:400px !important;" v-scroll-reveal.reset="{ delay: 250 }" src="/static/img/about/au/0309_people.jpg" alt="">
      </p>

        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};</script>

<style scoped>
.about-rad h3 {
    margin: 40px auto;
    width: 60%;
    text-align: center;
}
.about-rad p {
    font-size: 19px;
    line-height: 32px;
    margin: 15px auto;
    text-align: justify;
    width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/components/about/RAndD.vue